import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { ShoppingCart, Menu, X, Phone, PackageSearch } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { totalItems } = useCart();
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80">
      {/* Top bar */}
      <div className="bg-primary">
        <div className="container flex items-center justify-between py-1.5 text-xs text-primary-foreground">
          <div className="flex items-center gap-2 flex-wrap">
            <Phone className="h-3 w-3" />
            <span>+974 7066 6509</span>
            <span className="hidden sm:inline">| +974 4469 9340</span>
            <span className="hidden sm:inline">| +974 3999 3358</span>
            <span className="hidden sm:inline">| mmagroup20@outlook.com</span>
          </div>
          <span className="hidden sm:inline">47+ Years of Excellence in Qatar</span>
        </div>
      </div>

      {/* Main nav */}
      <div className="container flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-md bg-primary font-display text-base sm:text-lg font-bold text-primary-foreground">
            M
          </div>
          <div className="leading-tight">
            <span className="font-display text-base sm:text-lg font-bold text-foreground">MMA Group</span>
            <span className="block text-[10px] uppercase tracking-widest text-muted-foreground">Qatar</span>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors hover:text-accent ${
                location.pathname === link.to ? "text-accent" : "text-muted-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/track-order" className="hidden sm:inline-flex">
            <Button variant="ghost" size="sm" className="gap-1.5 text-muted-foreground hover:text-accent">
              <PackageSearch className="h-4 w-4" /> Track Order
            </Button>
          </Link>
          <Link to="/cart" className="relative" aria-label="Shopping cart">
            <Button variant="ghost" size="icon" aria-label="Shopping cart">
              <ShoppingCart className="h-5 w-5" />
              {totalItems > 0 && (
                <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-accent text-[10px] font-bold text-accent-foreground">
                  {totalItems}
                </span>
              )}
            </Button>
          </Link>
          <button className="md:hidden" aria-label={mobileOpen ? "Close menu" : "Open menu"} onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-border bg-card md:hidden">
          <nav className="container flex flex-col gap-1 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                  location.pathname === link.to ? "bg-accent/10 text-accent" : "text-foreground hover:bg-muted"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/track-order"
              onClick={() => setMobileOpen(false)}
              className={`rounded-md px-3 py-2.5 text-sm font-medium transition-colors flex items-center gap-2 ${
                location.pathname === "/track-order" ? "bg-accent/10 text-accent" : "text-foreground hover:bg-muted"
              }`}
            >
              <PackageSearch className="h-4 w-4" /> Track Order
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
